export const ROUND_ITEM_STATUS = Object.freeze({
  UNCHECKED: 'unchecked',
  DONE: 'done',
  NOT_DONE: 'not-done',
  IGNORED_NOT_DONE: 'ignored-not-done',
  MIXED: 'mixed',
});

export const ROUND_ITEM_STATUS_COLOR = Object.freeze({
  [ROUND_ITEM_STATUS.UNCHECKED]: '#0000ff65',
  [ROUND_ITEM_STATUS.DONE]: '#00ff1565',
  [ROUND_ITEM_STATUS.NOT_DONE]: '#ff000065',
  [ROUND_ITEM_STATUS.IGNORED_NOT_DONE]: '#ff7b0065',
  [ROUND_ITEM_STATUS.MIXED]: '#ff7b0065',
});

export function toRoundStatusMs(value) {
  if (!value) return null;

  if (value instanceof Date) {
    const time = value.getTime();
    return Number.isNaN(time) ? null : time;
  }

  let normalized = String(value).trim();
  if (!normalized) return null;

  normalized = normalized.replace(/(\.\d{3})\d+/, '$1');

  const hasTimezone = /([zZ]|[+\-]\d{2}:\d{2})$/.test(normalized);
  if (!hasTimezone) normalized += 'Z';

  const time = Date.parse(normalized);
  return Number.isNaN(time) ? null : time;
}

export function hasOpenFlaw(item) {
  const flaws = Array.isArray(item?.flaws) ? item.flaws : [];
  return flaws.some((flaw) => !flaw?.done);
}

export function isCheckedThisRound(item) {
  return !!item?.continueWithoutAdding || !!item?.controlled;
}

export function hasOpenFlawFromPreviousRound(item, roundCreated) {
  const flaws = Array.isArray(item?.flaws) ? item.flaws : [];
  const open = [...flaws].reverse().find((flaw) => !flaw?.done);
  if (!open) return false;

  const roundStart = toRoundStatusMs(roundCreated);
  const flawCreated = toRoundStatusMs(open?.created);

  if (roundStart == null || flawCreated == null) return true;

  return flawCreated < roundStart;
}

export function getRoundItemStatus(item, roundCreated) {
  if (!item) return null;

  if (item.flawScale) {
    return item.done ? ROUND_ITEM_STATUS.DONE : ROUND_ITEM_STATUS.NOT_DONE;
  }

  const open = hasOpenFlaw(item);
  const checkedThisRound = isCheckedThisRound(item);

  if (checkedThisRound) {
    return open ? ROUND_ITEM_STATUS.NOT_DONE : ROUND_ITEM_STATUS.DONE;
  }

  if (open) {
    return ROUND_ITEM_STATUS.IGNORED_NOT_DONE;
  }

  return ROUND_ITEM_STATUS.UNCHECKED;
}

export function getRoundGroupStatus(items, roundCreated) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return ROUND_ITEM_STATUS.UNCHECKED;

  const allChecked = list.every((item) => isCheckedThisRound(item));
  if (!allChecked) return ROUND_ITEM_STATUS.UNCHECKED;

  const flawedCount = list.filter(
    (item) => getRoundItemStatus(item, roundCreated) === ROUND_ITEM_STATUS.NOT_DONE
  ).length;

  if (flawedCount === list.length) return ROUND_ITEM_STATUS.NOT_DONE;
  if (flawedCount === 0) return ROUND_ITEM_STATUS.DONE;
  return ROUND_ITEM_STATUS.MIXED;
}

export function getRoundStatusColor(status) {
  return ROUND_ITEM_STATUS_COLOR[status] || ROUND_ITEM_STATUS_COLOR[ROUND_ITEM_STATUS.UNCHECKED];
}
